import React from 'react';

import PropTypes from 'prop-types';

import { MarkdownContent } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import cityToCityConfig from '../../../../config/c2c.locale';

import styles from './CarrierDescription.scss';

function CarrierDescription(props) {
    const {
        t,
        i18nMoney,
        carrierData,
    } = props;

    return (
        <div className={styles.container}>
            {carrierData.map((data) => {
                const {
                    carrierCode,
                    metrics,
                } = data;
                const {
                    minPriceUsd,
                    averagePriceUsd,
                    weekendPriceUsd,
                } = metrics;

                return (
                    <MarkdownContent key={carrierCode}>
                        {t(`${carrierCode}_description`, {
                            averageMinimumPrice: i18nMoney(minPriceUsd).format({
                                maximumFractionDigits: 0,
                                minimumFractionDigits: 0,
                            }),
                            averagePriceUsd: i18nMoney(averagePriceUsd).format({
                                maximumFractionDigits: 0,
                                minimumFractionDigits: 0,
                            }),
                            weekendPrice: weekendPriceUsd
                                ? i18nMoney(weekendPriceUsd).format({
                                    maximumFractionDigits: 0,
                                    minimumFractionDigits: 0,
                                })
                                : null,
                        })}
                    </MarkdownContent>
                );
            })}
        </div>
    );
}

CarrierDescription.propTypes = {
    carrierData: PropTypes.arrayOf(PropTypes.object),
};
CarrierDescription.defaultProps = {
    carrierData: [],
};

export { CarrierDescription };
export default localize(CarrierDescription, cityToCityConfig.namespace);
